import { Component, OnInit, Input } from '@angular/core';
import { RequiredActionService } from '../../../../shared/required-action.service';
import { BaseComponent } from '../../../../base.component';
import { ImplementOnsiteBlog } from '../../../../shared/models/required-actions/implement-onsite-blog';
import { takeUntil } from 'rxjs/operators';
import { SessionService } from '../../../../shared';

@Component({
  selector: 'app-implement-onsite-blog',
  templateUrl: './implement-onsite-blog.component.html',
  styleUrls: ['./implement-onsite-blog.component.css']
})
export class ImplementOnsiteBlogComponent extends BaseComponent implements OnInit {
  @Input() requiredAction: ImplementOnsiteBlog;

  public isCsr: boolean;

  constructor(private requiredActionService: RequiredActionService,
    private sessionService: SessionService) {
    super();
  }

  ngOnInit() {
    this.sessionService.isCsr.subscribe(isCsr => this.isCsr = isCsr);
  }

  public downloadAndClose() {
    window.open(this.requiredAction.hyperlink);
    return this.requiredActionService.completeTicket(this.requiredAction.completeTicketPayload)
      .pipe(
        takeUntil(this.unsubscribe)
      )
      .subscribe(() => {
        this.requiredActionService.loadRequiredActions();
      });
  }
}
